module.exports = __webpack_public_path__ + "img/banner1.5ee475b9.png";